import styled from 'styled-components';

export const Paragraph = styled('p')`
  font-size: 13px;
  padding: 0;
  margin: 0;
  display: block;
`;
export const SummaryBlock = styled('div')`
  padding: 0 0 15px 0;

  &:last-child {
    padding: 0;
  }
`;
